import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { without } from 'lodash';
import { PartnersSelectionDialogComponent } from './partners-dialog/partners-selection-dialog.component';
import { AutoUnsubscribe, DIALOG_DEFAULT_CONFIG, DialogSize, IconNames, ValidationService } from '../../common';
import { PartnerBrief } from '../../store/state/administration/partner/models';
import { PartnersSelectionItem } from './models';
import { PartnerType } from '../../store/state/administration/partner/constants';
import { PartnersSelectionItemWithType } from '../../store';

@Component({
    selector: 'container-partners-selection',
    templateUrl: './partners-selection.component.html',
    styleUrls: ['./partners-selection.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
@AutoUnsubscribe
export class PartnersSelectionComponent {
  @Input() isDataEditable: boolean;
  @Input() title: string;
  @Input() description: string;
  @Input() predefinedPartnerType: PartnerType;
  @Input() set partners(data: PartnersSelectionItemWithType[]) {
    if (data) {
      this.partnerList = data;
    }
  }
  @Output() listChange = new EventEmitter<PartnersSelectionItem[]>();
  subscriptions: Subscription[] = [];
  partnerList: PartnersSelectionItemWithType[];
  iconNameList = IconNames;

  constructor(public validationService: ValidationService, private dialog: MatDialog, private cd: ChangeDetectorRef) {}

  removePartner(partner: PartnersSelectionItemWithType): void {
    this.partnerList = [...without(this.partnerList, partner)];
    this.listChange.emit(this.partnerList);
    this.cd.markForCheck();
  }

  managePartners(): void {
    this.dialog
      .open(PartnersSelectionDialogComponent, {
        data: {
          ownerList: this.partnerList,
          predefinedType: this.predefinedPartnerType,
        },
        ...DIALOG_DEFAULT_CONFIG,
        width: DialogSize.LG,
      })
      .afterClosed()
      .subscribe((partners: PartnerBrief[]) => {
        if (partners) {
          this.partnerList = partners.map(({ id, name, type, extIds }: PartnerBrief) => ({
            id,
            name,
            type,
            extIds,
          }));

          this.listChange.emit(this.partnerList);
          this.cd.markForCheck();
        }
      });
  }
}
